export default __webpack_public_path__ + "static/media/Marianne-Light.0c3211fd.woff2";